var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarChartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.986,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2735 9.88292C35.502 9.87979 35.7103 9.94487 35.8985 10.0782C36.8493 10.7955 37.7738 11.5377 38.6719 12.3048C38.724 20.6382 38.724 28.9714 38.6719 37.3048C38.5931 37.4422 38.476 37.5334 38.3203 37.5782C36.3932 37.6303 34.4662 37.6303 32.5391 37.5782C32.2917 37.5392 32.1485 37.396 32.1094 37.1485C32.0573 28.9194 32.0573 20.6902 32.1094 12.461C32.1307 12.3182 32.1959 12.201 32.3047 12.1095C33.3086 11.378 34.2982 10.6358 35.2735 9.88292Z",
    fill: "#6A097D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.985,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3516 14.7266C25.5412 14.7284 25.7235 14.7674 25.8985 14.8438C26.7838 15.5209 27.6693 16.1979 28.5547 16.875C28.6757 16.9698 28.7668 17.087 28.8281 17.2266C28.8803 23.8932 28.8803 30.5599 28.8281 37.2266C28.7551 37.4298 28.6119 37.547 28.3985 37.5781C26.4713 37.6302 24.5443 37.6302 22.6172 37.5781C22.4777 37.5168 22.3605 37.4257 22.2656 37.3047C22.2135 30.5859 22.2135 23.8672 22.2656 17.1484C23.2864 16.322 24.3151 15.5147 25.3516 14.7266Z",
    fill: "#6A097D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.983,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4297 20.587C15.65 20.5673 15.8583 20.6064 16.0547 20.7042C17.0053 21.4464 17.9557 22.1885 18.9063 22.9307C18.9584 27.7224 18.9584 32.5141 18.9063 37.3057C18.8275 37.4432 18.7103 37.5343 18.5547 37.5792C16.6276 37.6313 14.7006 37.6313 12.7735 37.5792C12.526 37.5401 12.3828 37.3969 12.3438 37.1495C12.2917 32.462 12.2917 27.7745 12.3438 23.087C12.4314 22.921 12.5486 22.7778 12.6953 22.6573C13.6121 21.9656 14.5236 21.2755 15.4297 20.587Z",
    fill: "#6A097D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.98,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.50781 25.6633C5.79839 25.6243 6.05881 25.6895 6.28906 25.8586C7.04806 26.4875 7.8293 27.0864 8.63281 27.6554C8.80539 27.8018 8.9486 27.9711 9.0625 28.1633C9.11461 31.1841 9.11461 34.2049 9.0625 37.2258C8.98945 37.429 8.84625 37.5462 8.63281 37.5773C6.70573 37.6294 4.77865 37.6294 2.85156 37.5773C2.71203 37.516 2.59485 37.4249 2.5 37.3039C2.44792 34.231 2.44792 31.158 2.5 28.0851C3.46829 27.2339 4.47089 26.4266 5.50781 25.6633Z",
    fill: "#6A097D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChartIcon);
export default __webpack_public_path__ + "static/media/BarChartIcon.e3b9331187722040dcc636f997ee6334.svg";
export { ForwardRef as ReactComponent };